(ns frontend.ui.page.lp-portal.report.sub
  (:require
   ;; [frontend.ui.page.lp-portal.report.private-equity.controller.core :as private-equity-ctl]
   ;; [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.core :as real-estate-ctl]
   [re-frame.core :as rf]))

(def report-path [:lp-portal :lp-report])
(def holding-reports-path [:lp-portal :holding-reports])
(def materials-path [:lp-portal :material-files])
(def accessible-investor-attachments-path [:lp-portal :accessible-investor-attachments])

(def images-path [:lp-portal :report-images])

(def burned-pdfs-path [:lp-portal :burned-pdfs])

(def export-formats-path [:lp-portal :export-formats])

(def download-context-path (conj report-path :download))
(def download-open-path (conj download-context-path :show?))

(rf/reg-sub
 ::loading?
 (fn [db]
   (get-in db [::loading?])))

(rf/reg-sub
 ::report-details
 (fn [db]
   (get-in db report-path)))

(rf/reg-sub
 ::holding-reports
 (fn [db]
   (get-in db holding-reports-path)))

(rf/reg-sub
 ::materials
 (fn [db]
   (get-in db materials-path)))

(rf/reg-sub
 ::export-formats
 (fn [db]
   (get-in db export-formats-path)))

(rf/reg-sub
 ::accessible-investor-attachments
 (fn [db]
   (->> (get-in db accessible-investor-attachments-path)
        (map (fn [attachment]
               {:id    (:db/id attachment)
                :label (:attachment-filename attachment)}))
        (sort-by :label)
        (vec))))

(rf/reg-sub
 ::images
 (fn [db]
   (get-in db images-path)))

(rf/reg-sub
 ::burned-pdfs
 (fn [db]
   (get-in db burned-pdfs-path)))

(rf/reg-sub
 ::show-download?
 (fn [db]
   (get-in db download-open-path)))
